import { z } from 'zod';

import { TSDCarrierSchema, TSDCustomsOfficeSchema, TSDPersonPresentingTheGoodsSchema } from './utils';

export const TSDSendPresentationNotificationSchema = z.object({
  tsdId: z.string().min(1, { message: 'Required' }),
  generalInfo: z.object({
    dateAndTimeOfPresentationOfTheGoods: z.union([z.date(), z.string()]),
  }),
  carrier: TSDCarrierSchema.optional(),
  personPresentingTheGoods: TSDPersonPresentingTheGoodsSchema.optional(),
  customsOfficeOfPresentation: TSDCustomsOfficeSchema.optional(),
});

export type TSDSendPresentationNotificationData = z.infer<typeof TSDSendPresentationNotificationSchema>;
